import { useAssistantTransportSendCommand, useAuiState } from '@assistant-ui/react'
import { RefreshCw } from 'lucide-react'
import { createContext, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useThreadBusy } from './AgentActivityContext'
import { buildUserMessageCommand } from './messageIdentity'

/** Enabled only by the schema workbench, whose snapshot can rebuild model context. */
export const FreshContextRetryContext = createContext(false)

export function FailedSendRetry() {
  const { t } = useTranslation()
  const sendCommand = useAssistantTransportSendCommand()
  const allowFreshContext = useContext(FreshContextRetryContext)
  const failedSend = useAuiState(s =>
    s.message.isLast
      ? (s.message.metadata.custom as { failed_send?: { id?: string; text?: string } }).failed_send
      : undefined
  )
  const busy = useThreadBusy()
  if (!failedSend?.text) return null
  const text = failedSend.text
  const retry = (freshContext: boolean) =>
    sendCommand(buildUserMessageCommand(text, failedSend.id, { freshContext }))
  return (
    <div className="mt-1.5 space-y-2">
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={busy}
          onClick={() => retry(false)}
        >
          <RefreshCw className="size-3" />
          {t('chat.retryFailedSend')}
        </Button>
        {allowFreshContext && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={busy}
            onClick={() => retry(true)}
          >
            {t('schemaAgent.workbench.retryFreshContext')}
          </Button>
        )}
      </div>
      {allowFreshContext && (
        <p className="text-muted-foreground text-xs">
          {t('schemaAgent.workbench.retryFreshContextHint')}
        </p>
      )}
    </div>
  )
}
